/**
 * Moyasar publishable key for Payment Form (frontend only — never use secret key here).
 * CRA exposes REACT_APP_* vars at build time.
 */
export function getMoyasarPublishableKey() {
  return (process.env.REACT_APP_MOYASAR_PUBLISHABLE_KEY || '').trim();
}

export function isMoyasarTestMode(publishableKey) {
  return publishableKey.startsWith('pk_test_');
}
